module.exports = "/images/Bouncy House.svg?38e6558fa1301d4dec0e11ef13084ec0";